import { create } from 'zustand';
import { fetchSiteConfig } from '@/services/siteConfigApi';

interface SiteConfigStore {
  /** null until the first answer arrives. */
  loginEnabled: boolean | null;
  load: () => Promise<void>;
}

let inFlight: Promise<void> | null = null;

export const useSiteConfig = create<SiteConfigStore>((set) => ({
  loginEnabled: null,
  load: () => {
    inFlight ??= fetchSiteConfig().then((config) => set({ loginEnabled: config.loginEnabled }));
    return inFlight;
  },
}));
